import React from 'react';
import ServiceManagement from '../../components/admin/services/ServiceManagement';

const ServiceManagementPage = () => {
  return (
    <div className="p-6">
      {/* <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Service Management</h1>
        <p className="text-gray-600">Manage your services and offerings</p>
      </div> */}
      <ServiceManagement />
    </div>
  );
};

export default ServiceManagementPage;